/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-border-width',
  templateUrl: './theme-option-tooltips-border-width.component.html',
  styleUrls: ['./theme-option-tooltips-border-width.component.css']
})
export class ThemeOptionTooltipsBorderWidthComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_borderWidth';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_borderWidth', value);
  }

}
